






import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconCompleteAction extends Vue {
    @Prop({ type: Number, default: 16 }) readonly size!: number
}
